import React, { useState, useRef, useCallback } from "react";
import { Card } from "@components/_Revamp/StyledComponent";
import { styled } from "@linaria/react";
import { useAvivaDispatch, useAvivaSelector } from "@redux/hook";
import { ROUTE_PATH } from "@static/route-paths";
import { useHistory } from "react-router-dom";
import { SCREEN_SIZE } from "@static/screen-size";
import MainContainer from "@pages/EverGreen/Components/Container";
import Accordion from "@components/_Revamp/Accordion";
import { css } from "@linaria/core";
import { Text } from "@components/_Shared/Text";
import Bullet from "@pages/EverGreen/Components/Bullet";
import Modal from "@components/_Revamp/Modal";
import { themeDefault } from "src/theme-revamp";
import IconPencil from "@pages/EverGreen/Assets/Edit.svg";
import Link from "@pages/EverGreen/Components/Link";
import { PRODUCT_CODE_API, postValidateAdviser } from "@api/index";
import { Mapper } from "./FinancialAdviser";
import HealthMainContainer from "@components/_Revamp/HealthMainContainer";
import { updateShowArcPage } from "@redux/slices/CCP/step6Slice";
import { useDispatch } from "react-redux";

const Header = styled.div<{ marginTop?: string }>`
  width: 100%;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
  text-align: center;
  color: #434343;
  font-size: 18px;
  margin: 24px 0;
  @media (max-width: 767px) {
    margin: 5px 0 24px 0;
  }
`;

const modalPadding = css`
  .modal-body {
    padding: 24px 16px;
  }
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    .modal-body {
      padding: 36px;
    }
  }
`;

const SpiltUpContainer = styled.div<{ mariginTop?: string }>`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  margin-top: 24px;
  column-gap: 20px;
  row-gap: 24px;
  margin-top: ${(props) => props.mariginTop || "60px"};
  & div {
    width: 100%;
    flex-grow: 1;
  }
  @media screen and (max-width: 767px) {
    flex-direction: column;
    margin-top: 24px;
    grid-template-columns: repeat(1, 1fr);
    & div {
      display: flex;
      flex-direction: column;
      width: auto;
      flex-grow: 1;
      column-gap: 15px;
    }
  }
`;

const FieldLable = styled.div`
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 16px;
  @media screen and (max-width: 767px) {
    flex-direction: row !important;
  }
`;

const FieldValue = styled.div`
  font-style: normal;
  line-height: 140%;
  color: #434343;
  margin-top: 16px;
  font-weight: 600;
  font-size: 14px;
  @media screen and (max-width: 767px) {
    margin-bottom: 32px;
    font-size: 14px;
  }
  @media screen and (max-width: ${SCREEN_SIZE.mobilesUp}px) {
    margin-bottom: unset;
    font-size: 14px;
  }
`;

const ModalDescription = styled.div`
  font-style: normal;
  max-width: 588px;
  font-size: 14px;
  line-height: 140%;
  text-align: center;
  margin-top: 16px;
  letter-spacing: 0.015em;
  font-weight: 600;
  color: #8a8988;
`;

const CustomButton = styled.button<{ filled: boolean }>`
  border: none;
  display: flex;
  justify-content: center;
  font-size: 16px;
  font-weight: 600;
  height: 52px;
  background: ${(prop) =>
    prop.filled ? themeDefault.colors.primary : themeDefault.colors.white};
  align-items: center;
  text-align: center;
  letter-spacing: 0.08em;
  transition: all 0.2s linear;
  color: ${(prop) =>
    prop.filled ? themeDefault.colors.white : themeDefault.colors.primary};
  cursor: pointer;
  border: 1px solid #883E89;
  border-radius: 100px;
  max-width: 295px;
  width: 100%;
  @media (hover: hover) {
    &:hover {
      background: #883E89;
      color: #FFFFFF;
    }
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 24px;
  margin: 48px 0;
  flex-direction: column;
  width: 100%;
  align-items: center;

  @media (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    flex-direction: row;
  }
`;

const ModalButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 24px;
  margin: 56px 0 0 0;
  flex-direction: column;
  width: 100%;
  align-items: center;

  @media (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    flex-direction: row;
  }
`;

const importantNotes = [
  "If you are an existing Singlife customer, we’ll assign the latest active representative, either from Singapore Life Ltd. or from our distribution partners, who had sold our plans to you.",
  "If you are a new customer of Singlife or don’t have an active representative who have sold a Singlife plan to you, we’ll assign a dedicated Singlife Relationship Consultant.",
  "Once you’ve completed your purchase, we’ll email you the details of the assigned Financial Adviser Representative who will be servicing your policy.",
];

const container_default_css = css`
  margin-bottom: 130px;
`;

const title_default_css = css`
  font-family: "Open Sans";
  color: #434343;
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
  margin-left: 12px;
  @media screen and (min-width: 512px) {
    width: unset;
    font-size: 16px;
  }
`;

const accordionArgs = {
  title:
    "Things to note when we assign a Financial Adviser Representative to you:",
  theme: themeDefault,
  className: container_default_css,
  titleClassName: title_default_css,
  headerPadding: "24px 24px 24px 0",
  titleFontSize: 14,
  isExpanded: true,
  showBottomLine: true,
  showHeaderLine: true,
  bottomLineColor: "#c4c4c4",
  bottomLineThickness: "1px",
  contentMarginLeft: "0px",
  contentMarginRight: "0px",
  bottomLineClassName: "margin:10px",
  headerBackgroundColor: "#F4F6F9",
  showHeaderBackground: true,
};

const EditBtnParagraph = styled.p`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 140%;
  color: #883E89;
`;

export interface EditBtnProps {
  onClick?: (e: any) => void;
}

function ArcForm() {
  const history = useHistory();
  // const isChild = WhomTobuy === "child" ? true : false;
  // const [isJuvinal, setIsJuvinal] = useState(false);
  const dispatch = useDispatch();
  const [isShowModal, setIsShowModal] = useState(false);
  const DeclarationRef = useRef<null | HTMLDivElement>(null);
  const SpacerRef = useRef<null | HTMLDivElement>(null);

  const {FARData, financialAdviser} = useAvivaSelector((state) => state.cancerCoverStep6);
  const customerId = useAvivaSelector((state) => state.cancerCoverStep4.myInfo.customerId);
  const encryptedPromoCode = useAvivaSelector(
    (state) => state.cancerCoverStep6.promoCode
  );

  const EditComponent = ({ onClick }: EditBtnProps) => {
    return (
      <Link
        text="Edit"
        onClick={() => {
          dispatch(updateShowArcPage(false))
         
        }}
        icon={IconPencil}
        theme={themeDefault}
        color={themeDefault.colors.primary}
        fontSize={14}
        fontSizeTablet={14}
        variant="button"
      />
    );
  };

  const onContinue = useCallback(() => {
    const payload = {
      agentCode: FARData.code || "",
      promoCode: encryptedPromoCode || "",
      agentSelectedType: Mapper["own-adviser"],
      clientNo: "",
      loggedInUserId: 0,
      loginUser: "",
      requesterClientNumber: "",
      sourceSystem: "CCP",
      customerId: Number(customerId),
    };
    postValidateAdviser(
     FARData.code || "",
      PRODUCT_CODE_API.CANCER_COVER,
      payload
    );
    history.push(ROUTE_PATH.CANCER_COVER_REVIEW);
  }, [customerId, FARData.code, history]);

  const isPromoCodeValid = 'validPromoCode' in financialAdviser?.adviserData &&  financialAdviser?.adviserData?.validPromoCode === "Y";
  return (
    <>
      <HealthMainContainer
        backButtonPath={ROUTE_PATH.CANCER_COVER_DECLARATION}
        stepList={[]}
        step={3}
      >
          <Card padding={"24px 64px"} opacityValue="uset" marginTop="0">
            <Header>This adviser will be assigned to your policy</Header>
            <SpiltUpContainer mariginTop="24px">
              <div>
                <FieldLable>
                  Adviser's Code { !isPromoCodeValid && <EditComponent />}
                </FieldLable>
                <FieldValue>{FARData?.code || "-"}</FieldValue>
              </div>
              <div>
                <FieldLable>Adviser's Name</FieldLable>
                <FieldValue>
                  {financialAdviser?.adviserData?.data
                    ?.fullName ||
                   FARData?.name ||
                    "-"}
                </FieldValue>
              </div>
            </SpiltUpContainer>
          </Card>
          <ButtonContainer>
            <CustomButton filled={true} onClick={onContinue}>
              Continue
            </CustomButton>
          </ButtonContainer>
          <Accordion {...accordionArgs}>
            <div style={{ paddingBottom: "20px", paddingTop: "20px" }}>
              {importantNotes.map((note: string, index: number) => {
                if (index === importantNotes.length - 1) {
                  return (
                    <Text variant="base" fontSize="14px">
                      {note}
                    </Text>
                  );
                }
                return (
                  <Bullet key={`${index}`} fontSize={14}>
                    <Text variant="base" fontSize="14px">
                      {note}
                    </Text>
                  </Bullet>
                );
              })}
            </div>
          </Accordion>
        </HealthMainContainer>
      <Modal
        onClose={() => {
          setIsShowModal(false);
        }}
        show={isShowModal}
        colseBtnColor={themeDefault.colors.primary}
        className={modalPadding}
      >
        <>
          <Header marginTop={"0"}>Need help with your declaration?</Header>
          <ModalDescription>
            Contact us if you have any concerns or need help with any part of
            the declaration.
          </ModalDescription>
          <ModalButtonContainer>
            <CustomButton
              filled={false}
              onClick={() => {
                setIsShowModal(false);
                history.push(ROUTE_PATH.CANCER_COVER_LANDING_PAGE);
              }}
            >
              Back to home
            </CustomButton>
            <CustomButton
              filled={true}
              onClick={() => {
                // dispatch(updateDeclaration(true));
                history.push(ROUTE_PATH.CANCER_COVER_CONTACT_US);
              }}
            >
              Contact us{" "}
            </CustomButton>
          </ModalButtonContainer>
        </>
      </Modal>
      <div ref={SpacerRef}></div>
    </>
  );
}
export default ArcForm;
